import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';
import axios from 'axios';

const ImageUploadModal = ({ uploadAgain }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [file, setFile] = useState(null);
  const toast = useToast();

  const handleFileChange = event => {
    setFile(event.currentTarget.files[0]);
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      await axios.post(
        'https://admin.i-panel.pro:8787/api/files/upload',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      toast({
        title: 'Success!',
        description: 'Image uploaded successfully.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
      onClose();
    } catch (error) {
      toast({
        title: 'Error!',
        description: 'Failed to upload image.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
    await uploadAgain();
  };

  return (
    <>
      <Button onClick={onOpen}>загрузить свое</Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Загрузить изображение</ModalHeader>
          <ModalCloseButton />
          <Formik initialValues={{ file: null }} onSubmit={handleSubmit}>
            {() => (
              <Form>
                <ModalBody>
                  <FormControl>
                    <FormLabel htmlFor="file">Выберите файл</FormLabel>
                    <Input
                      type="file"
                      id="file"
                      name="file"
                      onChange={handleFileChange}
                    />
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <Button colorScheme="blue" mr={3} type="submit">
                    Загрузить
                  </Button>
                  <Button onClick={onClose}>Отмена</Button>
                </ModalFooter>
              </Form>
            )}
          </Formik>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ImageUploadModal;
